// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { DBBaseElement } from './DBBaseElement';
import { IndexConstraint } from './IndexConstraint';
import { DBColumn } from './DBColumn';
/**
 * 索引列 实体类
 * 索引列
 */
export class IndexColumn extends DBBaseElement {
  /** 是否包含 : 是否包含 */
  private _isInclude: boolean;

  /** 设置：是否包含 */
  public get isInclude() {
    return this._isInclude;
  }

  /** 获取：是否包含 */
  public set isInclude(value: boolean) {
    this._isInclude = value;
  }

  /** 是否升序 : 是否升序 */
  private _isAsc: boolean;

  /** 设置：是否升序 */
  public get isAsc() {
    return this._isAsc;
  }

  /** 获取：是否升序 */
  public set isAsc(value: boolean) {
    this._isAsc = value;
  }

  /** 索引约束 的ID */
  private _indexConstraint_ID: string;

  /** 获取：索引约束 的ID */
  public get indexConstraint_ID() {
    return this._indexConstraint_ID;
  }

  /** 设置：索引约束 的ID */
  public set indexConstraint_ID(value: string) {
    this._indexConstraint_ID = value;
  }

  /** 索引约束  */
  private _indexConstraint: IndexConstraint;

  /** 获取：索引约束  */
  public get indexConstraint() {
    return this._indexConstraint;
  }

  /** 设置：索引约束  */
  public set indexConstraint(value: IndexConstraint) {
    this._indexConstraint = value;
    if (value !== null) {
      this.indexConstraint_ID = value.id;
    } else {
      this.indexConstraint_ID = '';
    }
  }

  /** 数据库列 的ID */
  private _column_ID: string;

  /** 获取：数据库列 的ID */
  public get column_ID() {
    return this._column_ID;
  }

  /** 设置：数据库列 的ID */
  public set column_ID(value: string) {
    this._column_ID = value;
  }

  /** 数据库列  */
  private _column: DBColumn;

  /** 获取：数据库列  */
  public get column() {
    return this._column;
  }

  /** 设置：数据库列  */
  public set column(value: DBColumn) {
    this._column = value;
    if (value !== null) {
      this.column_ID = value.id;
    } else {
      this.column_ID = '';
    }
  }

  constructor() {
    super();
    this._isInclude = false;
    this._isAsc = false;
    this._indexConstraint_ID = '';
    this._indexConstraint = null;
    this._column_ID = '';
    this._column = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: IndexColumn, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isInclude = element.isInclude;
      this.isAsc = element.isAsc;
      this.indexConstraint_ID = element.indexConstraint_ID;
      if (hasReference && element.indexConstraint !== null) {
        this.indexConstraint = element.indexConstraint;
      }
      this.column_ID = element.column_ID;
      if (hasReference && element.column !== null) {
        this.column = element.column;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isInclude = json.IsInclude;
    this.isAsc = json.IsAsc;
    this.indexConstraint_ID = json.IndexConstraint_ID;
    // if (json.IndexConstraint !== null) {
    //   this.indexConstraint = IndexConstraint.Create(json.IndexConstraint);
    // }
    this.column_ID = json.Column_ID;
    // if (json.Column !== null) {
    //   this.column = DBColumn.Create(json.Column);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsInclude = this.isInclude;
    json.IsAsc = this.isAsc;
    json.IndexConstraint_ID = this.indexConstraint_ID;
    json.Column_ID = this.column_ID;
  }

  static Create(json: any): IndexColumn {
    const indexColumn = new IndexColumn();
    indexColumn.Deserialize(json);
    indexColumn.json = json;
    return indexColumn;
  }
}
